import { connect } from 'react-redux';
import UserInfoComponent from '../components/UserInfoComponent';
import action from '../redux/actions/user';

const mapStateToProps = (state) => ({
  user: state.user,
});

const mapDispatchToProps = (dispatch) => ({
  updateUserInfoAction: (params) => dispatch(action.updateUserInfoAction(params)),
});

export default connect(mapStateToProps, mapDispatchToProps)(UserInfoComponent);
